import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { IconButton } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { CardContent } from "@mui/material";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Checkbox, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { keyframes } from "@mui/system";
import Pagination from "@mui/material/Pagination";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";
import { useParams } from "react-router-dom";
import { Switch } from "@mui/material";
  import Tooltip from '@mui/material/Tooltip';

// Authentication layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { Button } from "@mui/material";
import Register from "layouts/authentication/sign-up/cover";
import EditDoctorProfile from "./EditDoctorProfile";

function DoctorsRegistration() {

    const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;

  const [openModal, setOpenModal] = useState(false);
  const [selectedDealerId, setSelectedDealerId] = useState(null);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
const [openDelearModal, setOpenDelearModal] = useState(false);
const [selectedDelearId, setSelectedDelearId] = useState(null);
const [selectedDelearName, setSelectedDelearName] = useState(null);
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState("");
  const [devicename, setDevicename] = useState("");
  const [device_id, setDevice_id] = useState("");
  const [devices, setDevices] = useState([]);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
const [user, setUser] = useState(null);
   const [doctorTypes, setDoctorTypes] = useState([]);
   const [doctorList, setDoctorList] = useState([]);
const [selectedDoctorType, setSelectedDoctorType] = useState("");


    const [coordinatorList, setCoordinatorList] = useState([]);  

   const [openSwitchModalState, setOpenSwitchModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const navigate = useNavigate();
  const handleCloseDeleteModal = () => setDeleteModal(false);

  
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
const openSwitchModal = (id) => {
    setSelectedUserId(id);
    setOpenSwitchModal(true);
  };

  const handleSwitchClose = () => {
    setOpenSwitchModal(false);
    setSelectedUserId(null);
  };

  const fetchDoctorTypes = async () => {
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
        const response = await axios.get("/api/doctortype", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200) {
          const decrypted = decryptBody(response.data, secretKey);
          setDoctorTypes(decrypted || []);
        }
      } catch (err) {
        console.error("Error fetching doctor types:", err);
      }
    };

    useEffect(() => {
      fetchDoctorTypes();
    }, []);

   const handleSwitchUser = async () => {
    try {
      setLoading(true);
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
     const response = await axios.post(
      `/api/switch-to-admin/${selectedUserId}`,
      {}, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        const loginData = {
        userid: decryptedData.userid,
        username: decryptedData.username,
        role: decryptedData.role,
        token: decryptedData.token,
        authorities: decryptedData.authorities || [],
      };

      // ✅ Store in localStorage
      localStorage.setItem("loginData", JSON.stringify(loginData));

      console.log("After update:", JSON.parse(localStorage.getItem("loginData")));

      toast.success(`Role updated to ${decryptedData.role} for ${decryptedData.username}`);

      navigate('/Admindasboard');
       setTimeout(() => {
          window.location.reload();
        }, 100);
    }
  } catch (error) {
    console.error("Error switching user:", error);
    toast.error("Switch failed. Please try again.");
  } finally {
    setLoading(false);
  }
};
    const fetchcarecoordinators = async (pageNumber = 1) => {
      setLoading(true);

      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
  
        if (!token) throw new Error("Authentication token not found.");
  
        const response = await axios.get(`/api/doctorregistration/ccid/${userid}`, {
          params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (response.status === 200) {
          const decryptedData = decryptBody(response.data, secretKey);
          setCoordinatorList(decryptedData.content || []);
          setCurrentPage(decryptedData.number + 1);
          setTotalPages(decryptedData.totalPages);
          console.log("Decrypted Response Data:", decryptedData);        }
      } catch (error) {
        console.error("Error fetching Care Coordinators:", error);
        // toast.error("Failed to fetch device types.");
      } finally {
        setLoading(false); 
      }
    };
    

  useEffect(() => {
    fetchcarecoordinators(); 
   }, []);

 
  const handleOpenDelearModal = (DelearId,DelearName) => {
    setSelectedDelearId(DelearId);
    setSelectedDelearName(DelearName);

    setOpenDelearModal(true);
  };
  
  const handleCloseDelearModal = () => {
    setOpenDelearModal(false);
    setSelectedDelearId(null);
    setSelectedDelearName(null);

  };
  const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (searchTerm) {
      setCurrentPage(); 
    }
  }, [searchTerm]);
  
  useEffect(() => {
    if (searchTerm) {
      searchData(currentPage); 
    } else {
      fetchcarecoordinators(currentPage);
    }
  }, [searchTerm, currentPage]);
  
  
  const searchData = async (pageNumber = 1) => {
    setLoading(true);
     
      
 console.log("Search term before API call:", searchTerm);
  console.log("Selected doctor type before API call:", selectedDoctorType);  
       try {
         setLoading(true);
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData")).token;
     
 const requestBody = encryptBody(
      {
        ccid:userid,
        searchTerm: searchTerm,
        // doctorType: selectedDoctorType, // <-- pass doctor type
      },
      secretKey
    );   
       const response = await axios.post( `/api/doctorregistration/search`, requestBody, {
        params: { page: Math.max(0, pageNumber - 1) },  
            headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        console.log("Decrypted Search Response:", decryptedData); 
        setCoordinatorList(decryptedData.content || []);
        setCurrentPage(decryptedData.number + 1);
        setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error searching Care Coordinator:", error);
    } finally {
      setLoading(false);
    }
  };
   const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  const handleOpenEditModal = async (id) => {
          setSelectedId(id);
          setOpenEditModal(true);
    };
    const handleCloseEditModal = () => {
      setOpenEditModal(false);
      setSelectedId(null);
      fetchcarecoordinators(); 
    };
    const handleOpenDeleteModal = (id) => {
      setSelectedId(id);
      setDeleteModal(true);
    };
    const handleDelete = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        const encryptedData = encryptBody({ id: selectedId }, secretKey);
    
        const response = await axios.post("/api/doctorregistration/delete", encryptedData, {
          headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
        });
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success(decryptedResponse.message || "Doctor Profile deleted successfully!");
    
          setDeleteModal(false); 
          fetchcarecoordinators();
        }
      } catch (error) {
        toast.error(error.message || "Failed to delete Doctor Profile.");
      } finally {
        setLoading(false);
      }
    };
    const handleRowClick = (dealer) => {
      const { email, userid } = dealer?.basicprofile || {};
      const { role } = dealer || {};
    
      // Step 1: Get existing loginData
      let loginData = JSON.parse(localStorage.getItem("loginData")) || {};
    
      console.log("Before update:", loginData);
    
      // Step 2: Update fields if values are present
      if (email && userid && role) {
        loginData.username = email;
        loginData.userid = userid;
        loginData.role = role;
    
        // Step 3: Save updated loginData back to localStorage
        localStorage.setItem("loginData", JSON.stringify(loginData));
    
        console.log("After update:", JSON.parse(localStorage.getItem("loginData")));
    
        toast.success(`Role updated to ${role} for ${email}`);
        navigate('/Admindasboard');
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        console.log("Missing required fields in  object.");
      }
    };

    const handleToggle = async (id, currentStatus) => {
  const updatedStatus = !currentStatus;

  // 1️⃣ Find doctor object in the list
  const coordinator = coordinatorList.find(item => item.id === id);
    if (!coordinator) {
      toast.error("Coordinator not found");
      return;
    }

  // 2️⃣ Optimistic UI update
  setCoordinatorList(prevList =>
    prevList.map(item =>
      item.id === id ? { ...item, cstatus: updatedStatus } : item
    )
  );


  try {
    const secretKey = await fetchSecretKey();
    const token = JSON.parse(localStorage.getItem("loginData"))?.token;

    // 3️⃣ Send **full doctor object** to prevent null overwriting
    const payload = {
      ...coordinator,
      cstatus: updatedStatus, // override only the status
    };

    console.log("Payload before encryption:", payload);

    const encryptedData = encryptBody(payload, secretKey);

    // 4️⃣ Call your backend updateStatus API
    const response = await axios.post(
      "/api/doctorregistration/update",
      encryptedData,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      const decryptedResponse = decryptBody(response.data, secretKey);
 toast.success(
  updatedStatus ? " Deactivated successfully." : "Activated successfully."
);    }
  } catch (error) {
    // 5️⃣ Revert status if API fails
    setDoctorList(prevList =>
      prevList.map(item =>
        item.id === id ? { ...item, cstatus: currentStatus } : item
      )
    );

    toast.error(error.message || "Failed to update status.");
    console.error("Toggle error:", error);
  }
};

     
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading && (
              <Box
                sx={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  zIndex: 9999,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: 80, 
                    height: 80, 
                    animation: `${spinAnimation} 1.5s linear infinite`,
                  }}
                >
                  {dotPositions.map((pos, index) => (
                    <Box
                      key={index}
                      sx={{
                        width: 8, 
                        height: 8, 
                        borderRadius: "50%",
                        backgroundColor: "#2e7faeff", 
                        position: "absolute",
                        ...pos,
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}
      <MDBox mt={1} p={1} display="flex"  alignItems="center">
      <MDTypography variant="h5" sx={{ flex: 1 }}>
     Doctors Profiles
  </MDTypography>
  {/* <FormControl
  variant="outlined"
  sx={{
    minWidth: 200,
    "& .MuiOutlinedInput-root": {
      height: "45px", // match search input height
      borderRadius: "8px", // same rounded look
    },
    "& .MuiInputLabel-root": {
      top: "-6px", // align label like MDInput
    },
  }}
>
  <InputLabel id="doctor-type-label">Doctor Type</InputLabel>
  <Select
    labelId="doctor-type-label"
    value={selectedDoctorType}
    onChange={(e) => setSelectedDoctorType(e.target.value)}
  >
    <MenuItem value="">
      <em>All</em>
    </MenuItem>
    {doctorTypes.map((dt) => (
      <MenuItem key={dt.doctor_type} value={dt.doctor_type}>
        {dt.doctor_type}
      </MenuItem>
    ))}
  </Select>
</FormControl> */}
  <MDBox sx={{ flex: 2, display: "flex", justifyContent: "center" }}>
           <MDInput
        placeholder="Search Name or Contact"
        variant="outlined"
        fullWidth
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{
          maxWidth: "400px",
          backgroundColor: "#fff",
          borderRadius: "8px",
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton size="small">
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
        </MDBox>
        <MDBox sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>

        <MDButton variant="gradient" onClick={() => navigate("/CreateDoctorsProfile")}
          sx={{
    background: "#2e7faeff",
    color: "#fff", 
    "&:hover": {
      background:"#2e7faeff", 
    },
  }} 
          >
    Create Doctor Profile
    </MDButton>
    </MDBox>
   

      </MDBox>

      <MDBox sx={{ overflowX: "auto", width: "100%" }}>
  <TableContainer component={Paper} sx={{ mt: 3, border: "1px solid #ddd", borderRadius: "8px", boxShadow: "2px 4px 10px rgba(0,0,0,0.1)" }}>
    <Table sx={{ tableLayout: "auto", minWidth: "650", borderCollapse: "collapse" }}>
      
      {/* Table Head */}
      <TableHead>



        <TableRow sx={{ backgroundColor: "#2e7faeff"}}>
          {[ "Name","Date of Birth", "NMC Registered Number", "Year Of Registration","Verification Status", "Contact" ,"Actions"].map((header, index) => (
            <TableCell
              key={index}
              sx={{
                fontWeight: "bold",
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "7px",
//   minWidth: index === 0 ? "150px" : "2px",
// width: index === 0 ? "315px" : "195px",
                // minWidth: index === 0 ? 180 : 120,
                 width: index === 0 ? "250px" : "161px",
    maxWidth: index === 0 ? "311px" : "161px",

              whiteSpace: "normal",
    wordBreak: "break-word",
    overflow: "visible",
              }}
            >
              {header}
            </TableCell>
          ))}

       
  </TableRow>
      

      <TableBody>
        {coordinatorList.length > 0 ? (
          coordinatorList.map((dealer, index) => (
           <TableRow
  key={index}
  onClick={() => navigate(`/ViewDoctorProfile/${dealer.id}`)}
 sx={{
    cursor: "pointer",
    "&:nth-of-type(even)": { backgroundColor: "#fafafa" },
    "&:hover": { backgroundColor: "#f0f8ff" },            
  }}
>
           
               <TableCell sx={{ border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",

    whiteSpace: "normal",
    wordBreak: "break-word",
    overflow: "visible", }}>
                {dealer.firstname} {dealer.lastname}
              </TableCell>
              <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.dob} </TableCell>
              <TableCell sx={{ border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",

    whiteSpace: "normal",
    wordBreak: "break-word",
    overflow: "visible", }}>
                {dealer?.nmcRegisteredNumber}
               
              </TableCell> <TableCell sx={{ border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",

    whiteSpace: "normal",
    wordBreak: "break-word",
    overflow: "visible", }}>
                {dealer?.yearOfRegistration}
               
              </TableCell> <TableCell sx={{ border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",

    whiteSpace: "normal",
    wordBreak: "break-word",
    overflow: "visible",}}>
                {dealer?.verificationstatus}
               
              </TableCell>
 <TableCell sx={{ border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",

    whiteSpace: "normal",
    wordBreak: "break-word",
    overflow: "visible", }}>
                {dealer?.phonecountrycode} {dealer?.phoneNumber}
               
              </TableCell>
                {/* <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.age}
               
              </TableCell> */}
              {/* 
               
              </TableCell> */}
              {/* <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.gender}
              </TableCell>
               <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.martialStatus}
              </TableCell>
                <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.certificationvalidtill}
              </TableCell>
                <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.dob}
              </TableCell>
                <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.age}
              </TableCell> */}
                {/* <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.locationid}
              </TableCell> */}

             

              
                

               <TableCell sx={{textAlign: "center",border: "1px solid #ddd"}}>
                  <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", gap: 1   }}>
<Tooltip title={!dealer?.cstatus ? "Active" : "Inactive"} arrow>

               <Switch
                 checked={!dealer?.cstatus} 
                 onClick={(event) => event.stopPropagation()}
                 onChange={() => handleToggle(dealer.id, dealer?.cstatus)}
                 sx={{
                                     '& .MuiSwitch-switchBase': {
                                       color: '#9e9e9e', // grey thumb when OFF
                                     },
                                     '& .MuiSwitch-track': {
                                       backgroundColor: '#bdbdbd', // grey track when OFF
                                     },
                               
                                     '& .MuiSwitch-switchBase.Mui-checked': {
                                       color: '#4caf50', // green thumb when ON
                                     },
                                     '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                       backgroundColor: '#4caf50', 
                                     },
                                   }}  />
                                              </Tooltip>
               <IconButton onClick={(e) => {
  e.stopPropagation();      
  handleOpenEditModal(dealer.id);        
}}>
  <EditIcon color="default" />
</IconButton>
             
               {/* <TableCell sx={{ textAlign: "center",border: "1px solid #ddd" }}> */}
                

                 <IconButton
                   color="default"
                   
                   onClick={(event) => {
                    event.stopPropagation();
                    handleOpenDeleteModal(dealer.id);
                  }}                 >
                   <DeleteIcon />
                 </IconButton>
                   </Box>

               </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={8} align="center" sx={{ border: "1px solid #ddd", padding: "12px", fontStyle: "italic", color: "gray" }}>
              No Data Available.
            </TableCell>
          </TableRow>
        )}
      </TableBody>
      </TableHead>
      <Box mt={2} display="flex" justifyContent="center">
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="success"
             sx={{
    "& .MuiPaginationItem-root": {
      borderRadius: "4px",
      color: "#2e7faeff",          // Text color
      borderColor: "#2e7faeff",    // Border color if outlined
    },
    "& .MuiPaginationItem-root.Mui-selected": {
      backgroundColor: "#2e7faeff", // Selected background
      color: "#fff",                 // Selected text color
    },
    "& .MuiPaginationItem-root:hover": {
      backgroundColor: "#2e7faeff33", // Slight hover effect
    },
  }}
          />
        </Box>
    </Table>
  </TableContainer>
</MDBox>

     
      {openEditModal && (
            <EditDoctorProfile
              isOpen={openEditModal}
              onRequestClose={handleCloseEditModal}
              id={selectedId}
            />
          )}
         <Modal open={openSwitchModalState} onClose={handleSwitchClose}>
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <Card
      sx={{
        width: 400,
        border: "2px solid #1976d2", // or any custom border color
        borderRadius: 2,
        boxShadow: 6,
      }}
    >
      <CardContent sx={{ textAlign: "center", p: 3 }}>
        <Typography variant="h6" mb={2}>
          Are you sure you want to switch user?
        </Typography>

        <Box display="flex" justifyContent="space-around">
          <MDButton
            variant="gradient"
            color="success" // ✅ Success green button
            onClick={handleSwitchUser}
            disabled={loading}
          >
            Yes
          </MDButton>
          <MDButton
            variant="gradient"
            color="success"
            onClick={handleSwitchClose}
          >
            No
          </MDButton>
        </Box>
      </CardContent>
    </Card>
  </Box>
</Modal>

      <Modal open={deleteModal} onClose={handleCloseDeleteModal}>
        <Card sx={{ width: "400px", padding: 4, margin: "auto", mt: 15, textAlign: "center" }}>
          <MDTypography sx={{ mb: 3, fontSize: "16px", fontWeight: "bold" }}>
            Are you sure you want to delete this Doctor Profile?
          </MDTypography>
  <MDBox display="flex" justifyContent="space-around">
            <MDButton variant="gradient" onClick={handleDelete} sx={{ background: "red", color: "#fff" }}>
              Delete
            </MDButton>
            <MDButton
              variant="gradient"
              onClick={handleCloseDeleteModal}
              sx={{ background: "#2e7faeff", color: "#fff" }}
            >
              Cancel
            </MDButton>
          </MDBox>

        </Card>
      </Modal>
    </DashboardLayout>
  );
}

export default DoctorsRegistration;

